module.exports = __webpack_public_path__ + "img/niño73.094a5564.jpg";